// project import
import { NavigationMenu, Provider as AppBridgeProvider, RoutePropagator as AppBridgeRoutePropagator } from '@shopify/app-bridge-react';
import ScrollTop from 'components/ScrollTop';
import config from 'config';
import { isShopifyApp, UserAuthProvider } from 'context/UserAuthContext';
import MainLayout from 'layout/MainLayout';
import MinimalLayout from 'layout/MinimalLayout';
import Credentials from 'pages/apis-and-services/Credentials';
import Login from 'pages/authentication/Login';
import Register from 'pages/authentication/Register';
import DashboardDefault from 'pages/dashboard';
import AccountSettings from 'pages/extra-pages/AccountSettings';
import ExitIframe from 'pages/extra-pages/ExitIframe';
import SubscriptionsPage from 'pages/extra-pages/SubscriptionsPage';
import MapRecentZipCodes from 'pages/locations/MapRecentZipCodes';
import { ProtectedRoute } from 'pages/ProtectedRoute';
import Carriers from 'pages/warehouse-and-inventory/Carriers';
import Holidays from 'pages/warehouse-and-inventory/Holidays';
import HolidaySettings from 'pages/warehouse-and-inventory/HolidaySettings';
import Orders from 'pages/warehouse-and-inventory/Orders';
import Products from 'pages/warehouse-and-inventory/Products';
import TrackingNumbers from 'pages/warehouse-and-inventory/TrackingNumbers';
import TransitLog from 'pages/warehouse-and-inventory/TransitLog';
import Warehouses from 'pages/warehouse-and-inventory/Warehouses';
import { useEffect, useMemo } from 'react';
import { Routes, Route, useLocation, useNavigate } from 'react-router-dom';
// import Routes from 'routes';
import ThemeCustomization from 'themes';
import { getUrlForPath } from 'utils/functions';
import { shopifyAppConfig } from './shopify-app-config';
import ReactGA from 'react-ga4';
import { NoSubscriptionRequired } from 'pages/NoSubscriptionRequired';
import SubscriptionCallbackPage from 'pages/extra-pages/SubscriptionCallbackPage';
import { AdminRoute } from 'pages/AdminRoute';
import AdminDashboard from 'pages/dashboard/AdminDashboard';
import ForgotPassword from 'pages/authentication/ForgotPassword';

// ==============================|| APP - THEME, ROUTER, LOCAL  ||============================== //
const NotFound = () => {
    return (<>404 - Not Found</>)
}
const MainApp = () => {
    const location = useLocation();
    useEffect(() => {
      if(process.env.NODE_ENV === 'production'){
        ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search});
      }
    }, [location]);

    return <ThemeCustomization>
        <ScrollTop>
            <Routes>
                <Route element={<MinimalLayout />} >
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<Register />} />
                    <Route path="/forgot-password" element={<ForgotPassword step="email" />} />
                    <Route path="/forgot/:token" element={<ForgotPassword step="password" />} />
                </Route>
                <Route element={<ProtectedRoute />} >
                        <Route path="/" element={<DashboardDefault />} />
                        <Route path="/credentials" element={<Credentials />} />
                        <Route path="/maps/recent" element={<MapRecentZipCodes />} />
                        <Route path="/maps/recent/:zip" element={<MapRecentZipCodes />} />
                        <Route path="/warehouses" element={<Warehouses />} />
                        <Route path="/carriers" element={<Carriers />} />
                        <Route path="/orders" element={<Orders />} />
                        <Route path="/products" element={<Products />} />
                        <Route path="/tracking" element={<TrackingNumbers />} />
                        <Route path="/transit/:trackingNumber" element={<TransitLog />} />
                        <Route path="/holidays" element={<Holidays />} />
                        <Route path="/holiday/settings/:clientKey" element={<HolidaySettings />} />
                </Route>
                <Route element={<AdminRoute />} >
                        <Route path="/admin" element={<AdminDashboard />} />
                </Route>
                <Route element={<NoSubscriptionRequired />}>
                        <Route path="/settings" element={<AccountSettings />} />
                        <Route path="/subscriptions" element={<SubscriptionsPage />} />
                        <Route path="/subscription/callback" element={<SubscriptionCallbackPage />} />
                        <Route path="/ExitIframe" element={<ExitIframe />} />
                        <Route path="*" element={<NotFound />} />
                </Route>
            </Routes>
        </ScrollTop>
    </ThemeCustomization>
}

const ShopifyEmbededApp = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const history = useMemo(
      () => ({replace: (path) => navigate(path, {replace: true})}),
      [navigate],
    );
    const router = useMemo(
      () => ({
        location,
        history,
      }),
      [location, history],
    );
  
    return <AppBridgeProvider config={shopifyAppConfig} router={router}>
        <AppBridgeRoutePropagator location={location} />
        	{/* <NavigationMenu
                navigationLinks={[
                {
                    label: 'Dashboard',
                    destination: getUrlForPath("/")
                },
                {
                    label: 'Orders',
                    destination: getUrlForPath('/orders'),
                },
                {
                    label: 'Products',
                    destination: getUrlForPath('/products'),
                },
                {
                    label: 'Warehouses',
                    destination: getUrlForPath('/warehouses'),
                },
                {
                    label: 'Carriers',
                    destination: getUrlForPath('/carriers'),
                },
                {
                    label: 'Holidays',
                    destination: getUrlForPath('/holidays'),
                },
                {
                    label: 'Recent Users Map',
                    destination: getUrlForPath('/maps/recent'),
                },
                ]}
                matcher={(link, location) => link.destination === location.pathname}
            /> */}
        <ShopifyMainApp />
    </AppBridgeProvider>
};
const ShopifyMainApp = () => {
    if(process.env.NODE_ENV === 'production'){
      const GA_TRACKING_ID = "G-10S3MNKHE6"; // OUR GOOGLE ANALYTICS TRACKING ID
      ReactGA.initialize(GA_TRACKING_ID);
    }
    return <MainApp />
}

const AppWrapper = () => {
    if(process.env.NODE_ENV === 'production'){
      const GA_TRACKING_ID = "G-C4L5S4Q6GD"; // OUR GOOGLE ANALYTICS TRACKING ID
      ReactGA.initialize(GA_TRACKING_ID);
    }
    return <MainApp />
}


const App = () => {
    return <UserAuthProvider>
        <AppDecider />
    </UserAuthProvider>
}
const AppDecider = () => {

    if (isShopifyApp()) {
        return <ShopifyEmbededApp />
    }
    return <AppWrapper />
}

export default App;
